const Nameof = <T>(name: keyof T) => name;

export default Nameof;